import COUNTRIES from '../countries.translations'

import translations from './tantalum.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/tantalum'

export const tantalum: Metal = {
  id: 32,
  slug: 'tantalum',
  name: t.name,
  symbol: 'Ta',
  // The sheet's eight pins replace the four grouped placeholders: the three DRC
  // provinces and the three Rwandan sites are now separate, Minas Gerais stands in for
  // the AMG operation inside it, and Marble Bar replaces Wodgina. No operators — the
  // sheet names none. Four of the eight are provinces or a state rather than a mine, so
  // their coordinates are the administrative centre, not a pit head. Nigeria has no pin
  // even though the sheet puts it second at 19.1%.
  mines: [
    {
      name: 'Maniema (DRC)',
      region: t.mine0Region,
      slug: 'maniema',
      coordinates: [25.95, -2.95],
    },
    {
      name: 'North Kivu (DRC)',
      region: t.mine1Region,
      slug: 'north-kivu',
      coordinates: [29.0, -0.7],
    },
    {
      name: 'South Kivu (DRC)',
      region: t.mine2Region,
      slug: 'south-kivu',
      coordinates: [28.2, -3.0],
    },
    {
      name: 'Ngoma (Rwanda)',
      region: t.mine3Region,
      slug: 'ngoma',
      coordinates: [30.47, -2.19],
    },
    {
      name: 'Gatumba (Rwanda)',
      region: t.mine4Region,
      slug: 'gatumba',
      coordinates: [29.6, -1.87],
    },
    {
      name: 'Musha (Rwanda)',
      region: t.mine5Region,
      slug: 'musha',
      coordinates: [30.28, -1.93],
    },
    {
      name: 'Minas Gerais (Brazil)',
      region: t.mine6Region,
      slug: 'minas-gerais',
      coordinates: [-44.5, -18.5],
    },
    {
      name: 'Marble Bar (Australia)',
      region: t.mine7Region,
      slug: 'marble-bar',
      coordinates: [119.75, -21.17],
    },
  ],
  countries: [
    { name: COUNTRIES.democraticRepublicCongo, percent: 45.1 },
    { name: COUNTRIES.nigeria, percent: 19.1 },
    { name: COUNTRIES.rwanda, percent: 17.2 },
    { name: COUNTRIES.brazil, percent: 6.8 },
    { name: COUNTRIES.china, percent: 3.8 },
  ],
  important: true,
  // The sheet's three, in its order: the rest of the 3TG conflict minerals. Tin's sheet
  // names tantalum back, and gold's names all three, so the grouping is reciprocal.
  related: ['tin', 'gold', 'tungsten'],
  video: {
    name: 'tantalum',
    poster: '/mine-my-phone/images/posters/tantalum.jpg',
  },
  // Scores and imagery are authored here; every word comes from the translations file.
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 2, ...t.impacts.environmental },
      human: { severity: 3, ...t.impacts.human },
      geopolitical: { severity: 4, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 2, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
        credit: 'David Maenda Kithoko',
      },
      firstBento: [
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
          credit: 'David Maenda Kithoko',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'vertical',
          credit: 'David Maenda Kithoko',
        },
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
      secondBento: [
        {
          src: `${dir}/05.jpg`,
          orientation: 'horizontal',
          credit: 'Tom Stoddart / Getty',
        },
        {
          src: `${dir}/06.jpg`,
          orientation: 'horizontal',
          credit: 'David Maenda Kithoko',
        },
      ],
    },
  },
}
